module.exports = __webpack_public_path__ + "img/13.531c88f2.jpg";